"use client";

import { useEffect } from "react";
import BlogCard from "@/app/components/ui/blog-card";
import FallbackMessage from "@/app/components/ui/fallback-message";
import { useServicesFilterStore } from "@/app/stores/services-filter-store";
import type { ServiceWithRelationsT } from "@/app/types/services";

interface ServicesGridProps {
  services: ServiceWithRelationsT[];
}

export default function ServicesGrid({ services }: ServicesGridProps) {
  const { setServices, filteredServices, isInitialized } =
    useServicesFilterStore();

  // Initialize store with services
  useEffect(() => {
    setServices(services);
  }, [services, setServices]);

  // Show loading state until store is initialized
  if (!isInitialized) {
    return (
      <div className="mt-8 grid grid-cols-1 gap-6 gap-y-8 md:mt-12 md:grid-cols-2 md:gap-y-12 lg:grid-cols-3">
        {services.map((service) => (
          <BlogCard
            key={service.id}
            image={
              service.thumbnailImageAsset?.url || service.thumbnail_image_url
            }
            title={service.title}
            subtitle={service.sub_title || ""}
            link={`/serviceleistungen/${service.slug}`}
            categories={service.categories}
            categoriesClickable={false}
            altText={
              service.thumbnailImageAsset?.alt_text ||
              service.thumbnail_image_alt ||
              ""
            }
          />
        ))}
      </div>
    );
  }

  return (
    <div className="mt-8 grid grid-cols-1 gap-6 gap-y-8 md:mt-12 md:grid-cols-2 md:gap-y-12 lg:grid-cols-3">
      {filteredServices.length > 0 ? (
        filteredServices.map((service) => (
          <BlogCard
            key={service.id}
            image={
              service.thumbnailImageAsset?.url || service.thumbnail_image_url
            }
            title={service.title}
            subtitle={service.sub_title || ""}
            link={`/serviceleistungen/${service.slug}`}
            categories={service.categories}
            categoriesClickable={false}
            altText={
              service.thumbnailImageAsset?.alt_text ||
              service.thumbnail_image_alt ||
              ""
            }
          />
        ))
      ) : (
        <FallbackMessage
          title="Keinen Service gefunden"
          description="Es gibt keine Serviceleistungen, die Ihren Suchkriterien entsprechen."
        />
      )}
    </div>
  );
}
